module.exports = __webpack_public_path__ + "img/Group (1).16895f41.svg";